import { Tag } from 'antd';

/**
 * @description BE `createdByRoleUnit` değerleri: medyayı ekleyen kurumsal birim. `MEDIA_OFFER_DECIDER`
 * aşama (statü) bazlıdır; birim ise daha kabadır — aynı birim birden çok aşamada işlem yapar
 * (ör. İH Madde Kontrol ve TS - İH Madde Kontrol ikisi de `ih`). Yalnız gösterim içindir; satır
 * sahipliği/yetki `createdByRole` ile ölçülmeye devam eder.
 */
export const MEDIA_OFFER_UNIT = {
  author: 'author',
  ih: 'ih',
  supervisor: 'supervisor',
  eu: 'eu',
  pub: 'pub',
};

/**
 * @description "Birim" kolonu rozeti: birim → Türkçe etiket + antd preset rengi. Renkler
 * `DECISION_MAKER_BADGE`'teki karşılık gelen ilk aşamanın rengiyle hizalıdır.
 * @type {Record<string, { label: string, color: string }>}
 */
const MEDIA_OFFER_UNIT_BADGE = {
  [MEDIA_OFFER_UNIT.author]: { label: 'Yazar', color: 'green' },
  [MEDIA_OFFER_UNIT.ih]: { label: 'İlim Heyeti', color: 'geekblue' },
  [MEDIA_OFFER_UNIT.supervisor]: { label: 'Madde Sorumlusu', color: 'blue' },
  [MEDIA_OFFER_UNIT.eu]: { label: 'Ansiklopedi Birimi', color: 'purple' },
  [MEDIA_OFFER_UNIT.pub]: { label: 'Yayın Müdürlüğü', color: 'volcano' },
};

/**
 * @description "Birim" kolonu rozeti: medyayı ekleyen birimi Türkçe etiket + renkle Tag olarak basar.
 * Eşleşme yoksa hiçbir şey render etmez.
 * @param {Object} props
 * @param {string|null} [props.unit=null] `MEDIA_OFFER_UNIT` değerlerinden biri.
 */
function MediaOfferUnitBadge({ unit = null }) {
  const badge = MEDIA_OFFER_UNIT_BADGE[unit];
  if (!badge) return null;
  return (
    <Tag
      color={badge.color}
      style={{ whiteSpace: 'normal', height: 'auto', maxWidth: '100%', wordBreak: 'break-word' }}
    >
      {badge.label}
    </Tag>
  );
}
export default MediaOfferUnitBadge;
